var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ding-overseas"},[_c('div',{staticClass:"ding-overseas-btn"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.toDingServer()}}},[_vm._v("Contact Us")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5c6cdc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dingWorkbench/overseas.vue
// module id = null
// module chunks = 